import React, { FC } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';
import ICONS from '../../constants/icons';

import { UserGroup } from './constant';

interface UserAccessGroupProps {
    title: string;
    count: number;
    role: UserGroup;
    onClick: (role: UserGroup) => void;
}
const UserAccessGroup: FC<UserAccessGroupProps> = ({
    title,
    count,
    onClick,
    role,
}) => {
    return (
        <UserGroupContainer onClick={() => onClick(role)}>
            <span>{title}</span>
            <UserNumberWithIcon>
                <span>{count}</span>
                <ICONS.compactRightArrow />
            </UserNumberWithIcon>
        </UserGroupContainer>
    );
};

const UserGroupContainer = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
});

const UserNumberWithIcon = styled.div({
    display: 'flex',
    gap: aampeTheme.spacing4(1),
    alignItems: 'center',
});

export default UserAccessGroup;
